import React, { useState } from 'react'
import PerScriptGridCard from './PerScriptGridCard'
import { endPoints } from '../../../utils/endpoints'
import { makeDeleteCall } from '../../../effects/requests'
import { ApiResponseType } from '../../../types'
import { emptyFunction, showToast } from '../../../utils'
import SrciptDetails from './SrciptDetails'

const PerScriptGridView = ({ allData, onRefresh, onView }: any) => {

    const [scriptData, setScriptData] = useState<any>(null)

    const onDelete = (scriptId: any) => {
        const url = `${endPoints.LOCATION_SCRIPT}${scriptId}`
        makeDeleteCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message, 'success');
                onRefresh?.()
            }
        }).catch(emptyFunction)
    }

    return (
        <>
            <div className={`lv-grid`}>
                {allData?.map((item: any) => {
                    return (
                        <PerScriptGridCard
                            key={item?.id}
                            item={item}
                            onDelete={onDelete}
                            onView={(data: any) => setScriptData(data)}
                            onClick={onView}
                        />
                    )
                })}
            </div>
            {scriptData?.id &&
                <SrciptDetails
                    onClose={() => setScriptData(null)}
                    srciptDetails={scriptData}
                    onRefresh={onRefresh}
                />
            }
        </>
    )
}

export default PerScriptGridView